import { breakpointAtLeast } from './utils.js';

(function ($) {
  var mapStyles = [
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#000000',
        },
        {
          weight: '1.05',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          weight: '1.02',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          hue: '#ff0000',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '27',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100',
        },
        {
          lightness: '68',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.stroke',
      stylers: [
        {
          weight: '0.01',
        },
        {
          saturation: '100',
        },
        {
          lightness: '-21',
        },
        {
          color: '#fccc9e',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '57',
        },
        {
          gamma: '2.51',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          saturation: '-100',
        },
        {
          lightness: '-32',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#f7f6f5',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#facaa3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          saturation: '-100',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffc59b',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffb363',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '33',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffbe71',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffdbb6',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '40',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fbe9d4',
        },
        {
          saturation: '-8',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffe7d5',
        },
        {
          weight: '0.84',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          saturation: '-100',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#d7e9f9',
        },
        {
          visibility: 'on',
        },
      ],
    },
  ];

  // Global variable with marker groups used in functions
  var markerGroups = get_marker_groups();
  // Save Markers by location
  var placeMarkerList = {};

  // Get marker groups from theme settings, passed by wp_localize_script()
  function get_marker_groups() {
    var markerGroups = [];
    var markerTypes = MAP_GLOBAL.markerTypes;

    if (markerTypes) {
      for (var i in markerTypes) {
        markerGroups[markerTypes[i].slug] = {
          markers: [],
          icon: markerTypes[i].map_icon,
        };
      }
    }

    return markerGroups;
  }

  /*
   *  This function will render a Google Map onto the selected jQuery element
   */
  function new_map($el) {
    var mapOptions = {
      zoom: 14,
      center: new google.maps.LatLng(51.50735, -0.12776),
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      overviewMapControl: false,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
    };

    // var geocoder = new google.maps.Geocoder();

    var map = new google.maps.Map($el[0], mapOptions);

    map.markers = [];

    var $markers = $el.siblings('.js-marker');
    var $toggledMarkers = $el.siblings('.js-toggled-marker');

    $toggledMarkers.each(function () {
      add_toggled_marker($(this), map);
    });

    $markers.each(function () {
      if (!$el.hasClass('js-project-map-canvas')) {
        add_marker($(this), map);
      } else {
        add_marker($(this), map, true);
      }
    });

    // Add a marker clusterer to manage the markers, but not on project map
    if (!$el.hasClass('js-project-map-canvas')) {
      // Parse every country to display a cluster for the country
      for (var country in placeMarkerList) {
        if (placeMarkerList.hasOwnProperty(country)) {
          var markerCluster = new MarkerClusterer(
            map,
            placeMarkerList[country],
            {
              styles: [
                {
                  url:
                    MAP_GLOBAL.themeDir +
                    '/resources/images/markers/circle.svg',
                  height: 45,
                  width: 45,
                  className: 'custom-clustericon',
                },
              ],
            },
          );
        }
      }
    }

    google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
      // console.log(this.getZoom())
      if (this.getZoom() > 15) {
        this.setZoom(15);
      }

      if ($el.hasClass('js-project-map-canvas-new')) {
        this.setZoom(16); // bigger zoom on project map
      }
    });

    center_map(map);

    // Offset map center because of NP floating map card (use its witdth)
    if ($el.hasClass('js-project-map-canvas-new')) {
      if (breakpointAtLeast('large')) {
        // console.log('pan for large up')
        map.panBy(-250, 0);
      } else if (breakpointAtLeast('medium')) {
        // console.log('pan for tablet')
        map.panBy(-150, 0);
      }
    }

    return map;
  }

  /**
   * Toggle visibility for group of markers.
   *
   * @param {string} type
   */
  function toggle_group(type) {
    for (var i = 0; i < markerGroups[type].markers.length; i++) {
      // alert(markerGroups[type][i]);
      var marker = markerGroups[type].markers[i];
      if (!marker.getVisible()) {
        marker.setVisible(true);
      } else {
        marker.setVisible(false);
      }
    }
  }

  function geocode_address(geocoder, address) {
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === 'OK') {
        return results[0].geometry.location;
      } else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });
  }

  /**
   * Add custom marker, which would be set to invisible by default.
   * This marker belong to some markers group. Visible on toggle_group().
   *
   * @param {jQuery object} $marker
   * @param {google map} map
   */
  function add_toggled_marker($marker, map) {
    var markerType = $marker.data('type');

    if (!markerGroups[markerType]) {
      return;
    }

    var markerIcon = markerGroups[markerType].icon;

    var latlng = new google.maps.LatLng(
      +$marker.attr('data-lat'),
      +$marker.attr('data-lng'),
    );
    // Maybe use geocoded address?
    // var latlng = geocode_address(geocoder, $marker.attr('data-address'));

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: {
        url: markerIcon,
        scaledSize: new google.maps.Size(50, 50),
      },
      title: '',
    });

    marker.setVisible(false);

    // add toggled marker type
    markerGroups[markerType].markers.push(marker);

    // add to array
    map.markers.push(marker);
    var content = $marker.html();

    if (content) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: content,
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * Get marker data from HTML and it to google map object
   *
   * @param {jQuery object} $marker
   * @param {google map} map
   * @param {boolean} useNewIcon
   */
  function add_marker($marker, map, useNewIcon) {
    var country = $marker.attr('data-country');
    var latlng = new google.maps.LatLng(
      +$marker.attr('data-lat'),
      +$marker.attr('data-lng'),
    );

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: useNewIcon
        ? MAP_GLOBAL.themeDir + '/resources/images/markers/pin-main.svg'
        : MAP_GLOBAL.themeDir + '/resources/images/markers/marker.png',
      title: '',
    });

    if (useNewIcon) {
      add_radius_circles(latlng, map);
    }

    // Apply country grouping if country attribute is available
    if (country) {
      if (!placeMarkerList.hasOwnProperty(country)) {
        placeMarkerList[country] = [];
      }

      // Save marker in place marker list
      placeMarkerList[country].push(marker);
    } else {
      // add to array
      map.markers.push(marker);
    }

    var content = $marker.html();

    if (content) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: content,
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  // Add Dashed circles with specified radius
  // See: https://stackoverflow.com/questions/52663470/drawing-a-circle-with-dashed-border-and-should-be-filled-with-color-in-google
  function add_radius_circles(latLng, map) {
    var lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 0.7,
      scale: 4,
    };
    var radius1 = 500;
    var radius2 = 1000;

    // first radius
    new google.maps.Polyline({
      path: drawCircle(latLng, radius1 / 1609.344, 1),
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: '0',
          repeat: '20px',
        },
      ],
      strokeWeight: 2,
      strokeColor: '#bec0c0',
      fillColor: 'transparent',
      fillOpacity: 0.1,
      map: map,
    });
    new google.maps.Circle({
      strokeWeight: 0,
      fillColor: 'transparent',
      fillOpacity: 0.5,
      map: map,
      center: latLng,
      radius: radius1,
    });

    // second radius
    new google.maps.Polyline({
      path: drawCircle(latLng, radius2 / 1609.344, 1),
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: '0',
          repeat: '20px',
        },
      ],
      strokeWeight: 2,
      strokeColor: '#bec0c0',
      fillColor: 'transparent',
      fillOpacity: 0.1,
      map: map,
    });
    new google.maps.Circle({
      strokeWeight: 0,
      fillColor: 'transparent',
      fillOpacity: 0.5,
      map: map,
      center: latLng,
      radius: radius2,
    });
  }

  /**
   * Center map to boundaries created by map markers.
   *
   * @param {google map} map
   */
  function center_map(map) {
    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    if (map.markers.length > 0) {
      $.each(map.markers, function (i, marker) {
        var latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng(),
        );
        bounds.extend(latlng);
      });
    }

    // loop through all markers grouped by country
    for (var country in placeMarkerList) {
      if (placeMarkerList.hasOwnProperty(country)) {
        // loop through all markers and create bounds
        $.each(placeMarkerList[country], function (i, marker) {
          var latlng = new google.maps.LatLng(
            marker.position.lat(),
            marker.position.lng(),
          );
          bounds.extend(latlng);
        });
      }
    }

    // only 1 marker?
    if (map.markers.length <= 1 && Object.keys(placeMarkerList).length <= 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(15);
    } else {
      map.fitBounds(bounds);
    }
  }

  function drawCircle(point, radius, dir) {
    var d2r = Math.PI / 180; // degrees to radians
    var r2d = 180 / Math.PI; // radians to degrees
    var earthsradius = 3963; // 3963 is the radius of the earth in miles

    var points = 32;

    // find the raidus in lat/lon
    var rlat = (radius / earthsradius) * r2d;
    var rlng = rlat / Math.cos(point.lat() * d2r);

    var extp = new Array();
    if (dir === 1) {
      var start = 0;
      var end = points + 1; // one extra here makes sure we connect the path
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      var ey = point.lng() + rlng * Math.cos(theta); // center a + radius x * cos(theta)
      var ex = point.lat() + rlat * Math.sin(theta); // center b + radius y * sin(theta)
      extp.push(new google.maps.LatLng(ex, ey));
    }
    return extp;
  }

  // Initialize maps
  if (typeof google !== 'undefined') {
    /*
     *  This function will render each map when the document is ready (page has loaded)
     */
    $(function () {
      var map = null;
      var $maps = $('.js-google-map');
      if ($maps.length) {
        $maps.each(function () {
          map = new_map($(this));
        });
      }

      // Show/hide custom markers
      $('.js-toggle-markers').on('click', function (e) {
        toggle_group($(this).data('type'));
        $(this).toggleClass('is-expanded');
      });
    });
  }
})(jQuery);
